import LegalPage from 'sly/legalPage';

export default LegalPage;

export async function getServerSideProps({
  params,
}: {
  params: { legalPage: string };
}) {
  return {
    props: {
      legalPage: params.legalPage,
    },
  };
}
